import React from "react";
import type { CustomField as TCustomField } from "src/components/Form/Form.types.ts";

export const CustomField = ({
  name,
  field,
  isLoading,
}: {
  name: string;
  field: TCustomField;
  isLoading?: boolean;
}) => {
  if (field.Component) {
    return <field.Component />;
  }
  if (field.element) {
    return field.element;
  }
  return null;
};
